import React, { useEffect, useRef, useState } from 'react';
import styles from '../../css/download.module.css'
import { postAsync } from '../../utils/httpClient';

// URL 이 파일 직접 다운로드인지 판별한다.
// 같은 항목이라도 환경에 따라 값이 달라지므로(dev = APK 직접 다운로드, sta = 플레이스토어)
// 속성을 고정하지 않고 URL 확장자로 판단한다.
const FILE_EXTENSIONS = ['.apk', '.exe', '.zip', '.msi', '.dmg', '.ipa'];

const isFileUrl = (href) => {
  if (!href) {
    return false;
  }
  // 쿼리스트링/해시를 떼고 경로 부분만 본다
  const path = href.split(/[?#]/)[0].toLowerCase();
  return FILE_EXTENSIONS.some((ext) => path.endsWith(ext));
};

// 다운로드 아이콘 링크
// href 가 아직 없을 때(API 응답 전) 눌러도 반응 없는 죽은 링크가 되지 않도록 안내를 띄운다.
const DownloadLink = ({ href, label }) => {
  if (!href) {
    return (
      <a
        className={styles.sub21_con01_2_right}
        href="#!"
        aria-label={`${label} (준비중)`}
        onClick={(e) => {
          e.preventDefault();
          alert('다운로드 링크를 불러오는 중입니다. 잠시 후 다시 시도해 주세요.');
        }}
      >
        <img src="/img10/sub21_ico01.png" alt="" />
      </a>
    );
  }

  // 파일 다운로드는 새 탭을 열면 빈 탭만 남으므로 현재 탭에서 처리한다.
  // (S3 처럼 교차 출처인 경우 download 속성은 무시되고 S3 의 Content-Disposition 이 우선한다)
  // 파일이 아니면 외부 페이지 이동이므로 새 탭으로 연다.
  const fileDownload = isFileUrl(href);

  return (
    <a
      className={styles.sub21_con01_2_right}
      href={href}
      aria-label={label}
      {...(fileDownload
        ? { download: true }
        : { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <img src="/img10/sub21_ico01.png" alt="" />
    </a>
  );
};

const Downloads = () => {

  const renderRef = useRef(true);
  const [link, setLink] = useState();

  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false; // 첫 렌더링 이후에는 두번 호출되지 않도록 설정
      postAsync('/v2/thirdparty/deliverycatch/download', {})
        .then((res) => {
          setLink(res.data)
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

  }, []);

  const handlePWAInstall = async (e) => {
    e.preventDefault(); // a 링크 기본 동작 막음

    // window 내장 객체에 저장한값 가져오기 (*route.js 에서 설정 참고)
    const promptEvent = window._deferredPrompt;
    // 저장값이 없을시 return
    if (!promptEvent) {
      return;
    }

    // 가져온 객체를 prompt 창으로 호출
    promptEvent.prompt();

    const result = await promptEvent.userChoice;
    if (result.outcome === "accepted") {
      console.log("설치 완료");
    } else {
      console.log("설치 취소");
    }

    window._deferredPrompt = null; // 한 번 쓰고 제거
  };

  // 모바일에선 'WEB 다운로드'(PWA 설치)를 안나오게 하기 위한 판별 (모바일인지 확인하는 정규식)
  const isMobile = /Mobi|iPhone|Android/i.test(navigator.userAgent);


  return (
    <div>
      <div id={styles.sub_con_warp}>
        <div className={styles.sub21_con01}>
          <ul>
            <li>
              <div className={styles.sub21_con01_title01}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>관제 프로그램</p>
                <p className={styles.sub21_text02}>사용자 편의에 따라 커스텀 설정 가능</p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (android)
                  </div>
                  <DownloadLink href={link?.adminWeb?.aos} label="CATCH 관제 APP (android) 다운로드" />
                </div>
                {/* PWA 설치는 모바일에서 노출하지 않는다 */}
                {!isMobile && (
                  <div className={styles.sub21_con01_3}>
                    <div className={styles.sub21_con01_2_left}>
                      WEB 다운로드
                    </div>
                    <a
                      className={styles.sub21_con01_2_right}
                      href="#!"
                      aria-label="CATCH 관제 WEB 앱 설치"
                      onClick={handlePWAInstall}
                    >
                      <img src="/img10/sub21_ico01.png" alt="" />
                    </a>
                  </div>
                )}
                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    WEB
                  </div>
                  <DownloadLink href={link?.adminWeb?.web} label="CATCH 관제 WEB 바로가기" />
                </div>
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title02}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>상점용 프로그램</p>
                <p className={styles.sub21_text02}>남녀노소 쉽게 사용 가능한 간편한 조작</p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    PC, POS (Windows)/Exe
                  </div>
                  <DownloadLink href={link?.store?.exe} label="캐치 상점 PC/POS 설치파일(exe) 다운로드" />
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    PC, POS (Windows)/Zip
                  </div>
                  <DownloadLink href={link?.store?.zip} label="캐치 상점 PC/POS 압축파일(zip) 다운로드" />
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (android)
                  </div>
                  <DownloadLink href={link?.store?.aos} label="캐치 상점 APP (android) 다운로드" />
                </div>
                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (ios)
                  </div>
                  <DownloadLink href={link?.store?.ios} label="캐치 상점 APP (ios) 다운로드" />
                </div>

              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title03}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>기사용 프로그램</p>
                <p className={styles.sub21_text02}>실시간 오더 위치 확인</p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (android)
                  </div>
                  <DownloadLink href={link?.rider?.aos} label="캐치 기사 APP (android) 다운로드" />
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    APP (ios)
                  </div>
                  <a
                    className={styles.sub21_con01_2_right}
                    href="#!"
                    aria-label="캐치 기사 APP (ios) - 준비중"
                    onClick={(e) => {
                      e.preventDefault();
                      alert('준비중입니다.');
                    }}
                  >
                    <img src="/img10/sub21_ico01.png" alt="" />
                  </a>
                </div>
                {/*
                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>APK 다운로드 (v1.29.6+74)</div>
                  <a
                    className={styles.sub21_con01_2_right}
                    href="https://catch-admin.s3.ap-northeast-2.amazonaws.com/download/rider/catch_rider_v1.29.6%2B74.apk"
                    aria-label="APK 다운로드 (v1.29.6+74)"
                    type="application/vnd.android.package-archive"
                    download
                  >
                    <img src="/img10/sub21_ico01.png" alt="" />
                  </a>
                </div>
                */}
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title04}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>원격 제어</p>
                <p className={styles.sub21_text02}>사용자 편의를위해 원격 제어를 제공합니다. </p>

                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    원격제어 프로그램
                  </div>
                  <DownloadLink
                    href='https://anydesk.com/ko/downloads/thank-you?dv=win_exe'
                    label='AnyDesk 원격제어 프로그램 다운로드'
                  />
                </div>
              </div>
            </li>
            <li>
              <div className={styles.sub21_con01_title04}>
                Download
              </div>
              <div className={styles.sub21_con01_1}>
                <p className={styles.sub21_text01}>기타 프로그램</p>
                <p className={styles.sub21_text02}>기타 다양한 프로그램</p>
                <div className={styles.sub21_con01_2}>
                  <div className={styles.sub21_con01_2_left}>
                    .NET 프레임워크 4.6.2
                  </div>
                  <DownloadLink
                    href='https://dotnet.microsoft.com/ko-kr/download/dotnet-framework/thank-you/net462-web-installer'
                    label='.NET 프레임워크 4.6.2 다운로드'
                  />
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    HHD 시리얼포트 모니터링 3.0.1
                  </div>
                  <DownloadLink
                    href='https://catch-admin.s3.ap-northeast-2.amazonaws.com/download/dist/hhdspmc.exe'
                    label='HHD 시리얼포트 모니터링 3.0.1 다운로드'
                  />
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    윈도우7 IE11 32비트
                  </div>
                  <DownloadLink
                    href='https://catch-admin.s3.ap-northeast-2.amazonaws.com/download/dist/EIE11_KO-KR_MCM_WIN7.EXE'
                    label='윈도우7 IE11 32비트 다운로드'
                  />
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    윈도우7 IE11 64비트
                  </div>
                  <DownloadLink
                    href='https://catch-admin.s3.ap-northeast-2.amazonaws.com/download/dist/EIE11_KO-KR_MCM_WIN764.EXE'
                    label='윈도우7 IE11 64비트 다운로드'
                  />
                </div>

                <div className={styles.sub21_con01_3}>
                  <div className={styles.sub21_con01_2_left}>
                    서브용 가맹점프로그램
                  </div>
                  <DownloadLink href={link?.store?.sub} label="서브용 가맹점 프로그램 다운로드" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Downloads;
